/* Shared Stellar collection menus. Native selects and Shopify filter URLs remain authoritative. */
(function () {
  'use strict';
  if (window.stellarPreviewDropdowns) return;

  var instances = new WeakMap();
  var controls = new Set();
  var openControl = null;
  var nextId = 0;
  var positionFrame = 0;

  function node(tag, className) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    return element;
  }

  function normalized(value) {
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
  }

  function enhance(select) {
    var id = select.id || ('cf-select-' + (++nextId));
    if (!select.id) select.id = id;
    var label = select.labels && select.labels[0];
    var labelSpan;

    // Support older preview markup without placing an interactive button inside a label.
    if (label && label.contains(select)) {
      var field = node('div', 'cf-field');
      var text = Array.prototype.filter.call(label.childNodes, function (child) { return child !== select; })
        .map(function (child) { return child.textContent; }).join('').trim();
      var replacement = node('label');
      replacement.htmlFor = id;
      replacement.id = label.id || (id + '-label');
      replacement.textContent = text || select.getAttribute('aria-label') || select.name || 'Choose';
      label.replaceWith(field);
      field.append(replacement, select);
      label = replacement;
    }

    labelSpan = node('span', 'cf-dropdown-label');
    labelSpan.id = id + '-dropdown-label';
    if (label) {
      while (label.firstChild) labelSpan.append(label.firstChild);
      label.append(labelSpan);
    } else {
      labelSpan.textContent = select.getAttribute('aria-label') || select.name || 'Choose';
      select.before(labelSpan);
    }

    var wrapper = node('div', 'cf-dropdown');
    wrapper.dataset.selectId = id;
    wrapper.style.position = 'relative';
    select.before(wrapper);
    wrapper.append(select);
    select.classList.add('cf-native-select');
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;

    var trigger = node('button', 'cf-dropdown-trigger');
    trigger.type = 'button';
    trigger.id = id + '-dropdown-trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    var value = node('span', 'cf-dropdown-value');
    value.id = id + '-dropdown-value';
    trigger.setAttribute('aria-labelledby', labelSpan.id + ' ' + value.id);
    if (label) label.htmlFor = trigger.id;
    var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    arrow.setAttribute('viewBox', '0 0 16 16');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.setAttribute('focusable', 'false');
    arrow.setAttribute('width', '16');
    arrow.setAttribute('height', '16');
    arrow.setAttribute('fill', 'none');
    arrow.setAttribute('stroke', 'currentColor');
    arrow.setAttribute('stroke-width', '1');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'm4 6 4 4 4-4');
    arrow.append(path);
    trigger.append(value, arrow);

    var menu = node('div', 'cf-dropdown-menu');
    menu.id = id + '-dropdown-menu';
    menu.setAttribute('role', 'listbox');
    menu.setAttribute('aria-labelledby', labelSpan.id);
    menu.tabIndex = -1;
    menu.hidden = true;
    menu.style.position = 'absolute';
    menu.style.left = '0';
    menu.style.minWidth = '100%';
    menu.style.overflowY = 'auto';
    trigger.setAttribute('aria-controls', menu.id);
    wrapper.append(trigger, menu);

    var entries = [];
    var activeIndex = -1;
    var typeBuffer = '';
    var lastTyped = 0;
    var isOpen = false;

    function enabled() { return entries.filter(function (entry) { return !entry.disabled; }); }
    function selected() { return entries.find(function (entry) { return entry.index === select.selectedIndex; }); }
    function active() { return entries.find(function (entry) { return entry.index === activeIndex; }); }
    function updateLabel() {
      var option = select.options[select.selectedIndex];
      value.textContent = option ? option.label : '';
      trigger.disabled = select.disabled || !enabled().length;
      trigger.setAttribute('aria-disabled', String(trigger.disabled));
      wrapper.classList.toggle('is-disabled', trigger.disabled);
    }

    function setActive(entry, scroll) {
      activeIndex = entry && !entry.disabled ? entry.index : -1;
      entries.forEach(function (item) { item.element.classList.toggle('is-active', item.index === activeIndex); });
      if (activeIndex < 0) { menu.removeAttribute('aria-activedescendant'); return; }
      menu.setAttribute('aria-activedescendant', entry.element.id);
      if (scroll && isOpen) {
        var top = entry.element.offsetTop;
        var bottom = top + entry.element.offsetHeight;
        if (top < menu.scrollTop) menu.scrollTop = top;
        else if (bottom > menu.scrollTop + menu.clientHeight) menu.scrollTop = bottom - menu.clientHeight;
      }
    }

    function close(restoreFocus) {
      if (!isOpen) return;
      isOpen = false;
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      wrapper.classList.remove('is-open', 'opens-up');
      typeBuffer = '';
      if (openControl === control) openControl = null;
      if (restoreFocus && !trigger.disabled) trigger.focus({ preventScroll: true });
    }

    function position() {
      if (!isOpen) return;
      var rect = trigger.getBoundingClientRect();
      var viewport = window.visualViewport;
      var viewportTop = viewport ? viewport.offsetTop : 0;
      var viewportBottom = viewportTop + (viewport ? viewport.height : innerHeight);
      if (rect.bottom <= viewportTop || rect.top >= viewportBottom) { close(false); return; }
      var below = Math.max(0, viewportBottom - rect.bottom - 16);
      var above = Math.max(0, rect.top - viewportTop - 16);
      var desired = Math.min(320, menu.scrollHeight);
      var up = below < desired && above > below;
      var height = Math.max(0, Math.min(320, up ? above : below));
      wrapper.classList.toggle('opens-up', up);
      wrapper.style.setProperty('--cf-menu-max-height', height + 'px');
      menu.style.maxHeight = height + 'px';
      menu.style.top = up ? 'auto' : 'calc(100% + 6px)';
      menu.style.bottom = up ? 'calc(100% + 6px)' : 'auto';
      var viewportLeft = viewport ? viewport.offsetLeft : 0;
      var viewportWidth = viewport ? viewport.width : innerWidth;
      var wrapperLeft = wrapper.getBoundingClientRect().left;
      menu.style.maxWidth = Math.max(0, viewportWidth - 40) + 'px';
      var menuWidth = menu.getBoundingClientRect().width;
      var minimumLeft = viewportLeft + 20;
      var maximumLeft = Math.max(minimumLeft, viewportLeft + viewportWidth - 20 - menuWidth);
      var menuLeft = Math.max(minimumLeft, Math.min(wrapperLeft, maximumLeft));
      menu.style.left = (menuLeft - wrapperLeft) + 'px';
    }

    function sync() {
      var prior = active();
      var priorValue = prior && prior.option.value;
      var fragment = document.createDocumentFragment();
      entries = [];
      Array.prototype.forEach.call(select.options, function (option, index) {
        if (option.hidden) return;
        var group = option.closest('optgroup');
        if (group && group.hidden) return;
        var disabled = option.disabled || !!(group && group.disabled);
        var element = node('div', 'cf-dropdown-option');
        element.id = id + '-dropdown-option-' + index;
        element.dataset.optionIndex = String(index);
        element.setAttribute('role', 'option');
        element.setAttribute('aria-selected', String(index === select.selectedIndex));
        element.setAttribute('aria-disabled', String(disabled));
        element.textContent = option.label;
        entries.push({ option: option, element: element, index: index, disabled: disabled });
        fragment.append(element);
      });
      menu.replaceChildren(fragment);
      updateLabel();
      if (trigger.disabled) close(false);
      var retained = isOpen && entries.find(function (entry) { return !entry.disabled && entry.option.value === priorValue; });
      var choice = selected();
      setActive(retained || (choice && !choice.disabled ? choice : enabled()[0]), false);
      if (isOpen) { position(); setActive(active(), true); }
    }

    function open(direction) {
      sync();
      if (trigger.disabled) return;
      if (openControl && openControl !== control) openControl.close(false);
      openControl = control;
      isOpen = true;
      menu.hidden = false;
      wrapper.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      position();
      if (!isOpen) return;
      var choice = selected();
      var choices = enabled();
      setActive(choice && !choice.disabled ? choice : choices[direction === -1 ? choices.length - 1 : 0], true);
      menu.focus({ preventScroll: true });
    }

    function choose(entry) {
      if (!entry || entry.disabled || select.disabled) return;
      select.value = entry.option.value;
      select.selectedIndex = entry.index;
      updateLabel();
      close(true);
      // Exactly one native change event; the existing render owns all filtering and sorting.
      select.dispatchEvent(new Event('change', { bubbles: true }));
      refresh();
    }

    function move(amount) {
      var choices = enabled();
      if (!choices.length) return;
      var current = choices.findIndex(function (entry) { return entry.index === activeIndex; });
      var next = current < 0 ? (amount > 0 ? 0 : choices.length - 1) : (current + amount + choices.length) % choices.length;
      setActive(choices[next], true);
    }

    function typeahead(character) {
      var now = performance.now();
      typeBuffer = now - lastTyped > 700 ? character : typeBuffer + character;
      lastTyped = now;
      var query = normalized(typeBuffer);
      var repeated = Array.from(query).every(function (letter) { return letter === query[0]; });
      if (repeated) query = query[0];
      var choices = enabled();
      var current = choices.findIndex(function (entry) { return entry.index === activeIndex; });
      var start = query.length === 1 ? current + 1 : Math.max(0, current);
      for (var i = 0; i < choices.length; i++) {
        var choice = choices[(start + i + choices.length) % choices.length];
        if (normalized(choice.option.label).startsWith(query)) { setActive(choice, true); break; }
      }
    }

    function keydown(event) {
      var key = event.key;
      if (key === 'Tab') {
        if (isOpen) { close(false); trigger.focus({ preventScroll: true }); }
        return;
      }
      if (key === 'Escape') {
        if (isOpen) { event.preventDefault(); event.stopPropagation(); close(true); }
        return;
      }
      if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Home' || key === 'End' || key === 'Enter' || key === ' ') {
        event.preventDefault(); event.stopPropagation();
        if (trigger.disabled) return;
        if (!isOpen) {
          open(key === 'ArrowUp' ? -1 : 1);
          if (key === 'Home') setActive(enabled()[0], true);
          if (key === 'End') setActive(enabled()[enabled().length - 1], true);
        } else if (key === 'Enter' || key === ' ') choose(active());
        else if (key === 'Home') setActive(enabled()[0], true);
        else if (key === 'End') setActive(enabled()[enabled().length - 1], true);
        else move(key === 'ArrowDown' ? 1 : -1);
      } else if (key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        event.preventDefault(); event.stopPropagation();
        if (!isOpen) open(1);
        if (isOpen) typeahead(key);
      }
    }

    trigger.addEventListener('click', function () { if (isOpen) close(true); else open(1); });
    trigger.addEventListener('keydown', keydown);
    menu.addEventListener('keydown', keydown);
    menu.addEventListener('pointermove', function (event) {
      var option = event.target.closest('[role="option"]');
      if (!option || !menu.contains(option)) return;
      var entry = entries.find(function (item) { return item.index === Number(option.dataset.optionIndex); });
      if (entry && !entry.disabled) setActive(entry, false);
    });
    menu.addEventListener('click', function (event) {
      var option = event.target.closest('[role="option"]');
      if (!option || !menu.contains(option)) return;
      event.preventDefault(); event.stopPropagation();
      choose(entries.find(function (entry) { return entry.index === Number(option.dataset.optionIndex); }));
    });
    select.addEventListener('change', sync);
    var control = { select: select, wrapper: wrapper, trigger: trigger, menu: menu, sync: sync, close: close, position: position };
    controls.add(control);
    instances.set(select, control);
    sync();
    return control;
  }

  function refresh() {
    controls.forEach(function (control) {
      if (!control.select.isConnected) { control.close(false); controls.delete(control); }
    });
    document.querySelectorAll('.cf-fields select').forEach(function (select) {
      var control = instances.get(select);
      if (control) control.sync(); else enhance(select);
    });
  }

  document.addEventListener('pointerdown', function (event) {
    if (openControl && !openControl.wrapper.contains(event.target)) openControl.close(false);
  }, true);
  document.addEventListener('focusin', function (event) {
    if (openControl && !openControl.wrapper.contains(event.target)) openControl.close(false);
  });
  document.addEventListener('toggle', function () {
    if (openControl && !openControl.trigger.getClientRects().length) openControl.close(false);
  }, true);
  function reposition() {
    if (!openControl || positionFrame) return;
    positionFrame = requestAnimationFrame(function () {
      positionFrame = 0;
      if (openControl) openControl.position();
    });
  }
  window.addEventListener('resize', reposition);
  window.addEventListener('scroll', reposition, true);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', reposition);
    window.visualViewport.addEventListener('scroll', reposition);
  }
  window.stellarPreviewDropdowns = { refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
